import React from 'react';
import { useCache } from '../../state/CachingContext';
import { IIDProvider } from '../../interfaces/';
import EmailCheckForm from './EmailCheckForm';
import ProviderPasswordForm from './ProviderPasswordForm';
import PasswordForm from './PasswordForm';

const LoginPage = (): JSX.Element => {
  const { getCache, setCache, clearCache } = useCache();
  const [idProviders, setIdProviders] = React.useState<IIDProvider[] | undefined>(undefined);

  const session = getCache();

  return (
    <>
      {!session.email ? (
        <EmailCheckForm
          onComplete={(email: string, idProviders?: IIDProvider[]) => {
            setCache('email', email);
            setIdProviders(idProviders);
          }}
        />
      ) : session && session.organisationsapplicationsguid ? (
        <ProviderPasswordForm
          email={session.email}
          idProviders={idProviders}
          reset={() => {
            clearCache('email');
            setIdProviders(undefined);
          }}
        />
      ) : (
        <PasswordForm
          email={session.email}
          reset={() => {
            clearCache('email');
            setIdProviders(undefined);
          }}
        />
      )}
    </>
  );
};

export default LoginPage;
